// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3355":"0e6c8c787f156695","8237":"5c5974ea0c6e7b7d","8261":"4f9c50289e3137d9","9173":"2a3258196e0d0b3e"}[chunkId] + ".css";
};